// namespace
export const SPEECHES_NAMESPACE = 'speeches'

// getters
export const SPEECHES_GETTER = 'speeches'
export const FILE_GETTER = 'speechesFile'

// mutations
export const SPEECHES_MUTATION_SINGLE_ENTRY = 'updateSpeechesFromSingleEntry'
export const SPEECHES_MUTATION_FILE = 'updateSpeechesFile'
export const SPEECHES_MUTATION_ENTIRE_SPEECHES = 'updateEntireSpeeches'

// actions
export const SPEECHES_ACTION_GET_SPEECHES = 'fetchSpeeches'
export const SPEECHES_ACTION_SAVE_SPEECHES = 'saveSpeeches'
export const SPEECHES_ACTION_SAVE_FILE = 'saveFile'

// defs
export const SPEECHES_TYPE_DEATH_NOTICE = 'deathNotice'
export const SPEECHES_TYPE_BURIAL_SPEECH = 'burialSpeech'
export const SPEECHES_TYPE_CEREMONY_SPEECH = 'ceremonySpeech'



// WEBPACK FOOTER //
// ./src/store/modules/speeches-types.js